import { cookie, } from './index.js';

let BASE_URL = '';
let CR = pageInfo?.cr || 'US';
let timeout = null;

// 生产环境 接口域名
const prodUrl = "https://api.myjackery.com"
const awsProdUrl = "https://aws-gateway.hijackery.cn"
// uat环境 接口域名
const uatUrl = "https://api-uat.myjackery.com"
const awsUatUrl = "https://aws-gateway-uat.hijackery.cn"
// 开发环境 接口域名
const devUrl = "https://demo-api.myjackery.com"
const awsDevUrl = "https://10.1.74.145:8093"

switch (pageInfo?.env) {
  case "prod": BASE_URL = prodUrl; break;
  case "demo": BASE_URL = devUrl; break;
  case "uat": BASE_URL = uatUrl; break;
  default: BASE_URL = prodUrl; break;
}

const lang = pageInfo?.lang || 'en';

const initial = {
  method: 'GET', params: null, body: null, cache: 'no-cache', credentials: 'include', responseType: 'JSON', mode: 'cors',
  headers: {
    cr: CR,
    lang
  }
};

function request(url, config, settings) {
  if (settings && settings.type == 'it-java') {
    BASE_URL = BASE_URL === prodUrl || BASE_URL === awsProdUrl ? awsProdUrl : BASE_URL === uatUrl || BASE_URL === awsUatUrl ? awsUatUrl : awsDevUrl
  } else {
    BASE_URL = BASE_URL === prodUrl || BASE_URL === awsProdUrl ? prodUrl : BASE_URL === uatUrl || BASE_URL === awsUatUrl ? uatUrl : devUrl
  }


  // init params
  if (typeof url !== 'string') throw new TypeError('url must be required and of string type');
  if (config && config.constructor === Object) {
    config = Object.assign(initial, config)
  } else {
    config = initial
  }
  let { method, params, body, headers, cache, credentials, responseType, check_jackery_token, } = config;

  // 处理URL：请求前缀 & 问号参数
  if (!/^http(s?):\/\//i.test(url)) { url = BASE_URL + url }
  if (params != null) {
    if (params.constructor === Object) {
      const values = Object.values(params);
      const keys = Object.keys(params);
      const arr = [];
      for (let i = 0; i < values.length; i++) {
        arr.push(`${keys[i]}=${values[i]}`)
      }
      params = arr.join("&")
    }
    url += `${url.includes('?') ? '&' : '?'}${params}`
  }

  // 根据自己的需求来:body传递的是普通对象，我们今天项目需要传递给服务器的是URLENCODED格式，我们才处理它的格式；如果用户传递的本身就不是普通对象(例如:文件流、字符串、FORM-DATA...)，还是以用户自己写的为主...
  if (body && body.constructor === Object) {
    headers['Content-Type'] = 'application/json';
    body = JSON.stringify(body);
  } else if (body && ((settings && settings.feature == 'upload') || body.constructor === File)) {
    // headers['Content-Type'] = 'multipart/form-data';
    if (headers['Content-Type'] == 'application/json') {
      delete headers['Content-Type']
    }
  } else if (typeof body === 'string') {
    try {
      // 是JSON字符串
      body = JSON.parse(body);
      headers['Content-Type'] = 'application/x-www-form-urlencoded';
    } catch (err) {
      // 不是JSON字符串:可以简单粗暴的按照URLECCODED格式字符串处理
      headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }
  }

  // 类似于AXIOS中的请求拦截器，例如：我们每一次发请求都需要携带TOKEN信息
  let token = "";
  if(check_jackery_token && check_jackery_token != "") {
    token = check_jackery_token;
  } else {
    token = cookie.get("_jk_user");
  }
  if (token) {
    headers.jackeryToken = token
  }


  // jackery-life 三方代码 需要
  if (settings && settings.headers?.authorization) {
    headers.Authorization = settings.headers.authorization
  }


  // 把config配置成为fetch需要的对象
  config = {
    method: method.toUpperCase(), headers, credentials, cache
  };
  if (/^(POST|PUT|PATCH)$/i.test(method) && body != null) { config.body = body }

  // 发送请求
  return fetch(url, config).then((r) => {
    let { status, statusText } = r;
    // 只要状态码是以2或者3开始的，才是真正的获取成功
    if (status >= 200 && status < 400) {
      let result;
      switch (responseType.toUpperCase()) {
        case 'JSON': result = r.json(); break;
        case 'TEXT': result = r.text(); break;
        case 'BLOB': result = r.blob(); break;
        case 'ARRAYBUFFER': result = r.arrayBuffer(); break;
      }
      return result
    }
    if(status === 422) {
      return r.json().then(errorData => {
        const message = errorData.message || statusText;
        return Promise.reject({ code: 'STATUS ERROR', status, statusText: message });
      });
    } else {
      return Promise.reject({ code: 'STATUS ERROR', status, statusText })
    }
  }).then((r) => {
    // 处理OS接口和第三方接口的状态
    if (r.code || r.code >= 0) {
      switch (r.code) {
        case 200: return Promise.resolve(r);
        case 10000:
          shopifyLogout().finally(() => {
            localStorage.removeItem("JACKERY_USER_TOKEN");
            cookie.erase("_jk_user");
            // 防止多次刷新
            clearTimeout(timeout);
            timeout = setTimeout(() => {
              window.location.href = window.location.origin + window.location.pathname
            }, 1000)
          });
          return Promise.reject(r);
        case 30001: case 30002:
          pushMessage("The Order ID does not exist, please try a different one.", "warning");
          return Promise.reject(r);
        case 50005:
          pushMessage("The email provided has been used.", "warning");
          return Promise.reject(r);
        default:
          return Promise.reject(r);
      }
    } else {
      return Promise.resolve(r)
    }
  }).catch((e) => {
    if (e && e.code === 'STATUS ERROR') {
      // @1 状态码错误
      switch (e.status) {
        case 400: break;
        case 401: break;
        case 404: break;
        case 422:
          e.statusText && pushErrorMessage(e.statusText);
          break;
        case 50006: break;
        default: pushErrorMessage("Oops, something went wrong, Please try again later."); break;
      }
    } else if (!navigator.onLine) {
      console.log("网络中断")
    }
    return Promise.reject(e)
  })
}

export const post = (url, body, settings) => request(url, { method: 'POST', body }, settings);
export const postDownload = (url, body, settings) => request(url, { method: 'POST', body, responseType: 'BLOB' }, settings);

export const get = (url, params, settings) => request(url, { method: 'GET', params, }, settings);

export const shopCR = CR;

export const getCountryApi_test = () => get("/osconsumerapi/shopify/shop-lists", { shopify_shop_id: shopId });

// get product all info
// { shopify_shop_id, sku }
export const getGoodsInfo = (param) => get("/osconsumerapi/v1/goods/info", param);



// 获取套装商品详情
export const getPackagedInfo = (param) => get("/osconsumerapi/v1/goods/packaged-info", param);

// shopify host logout
export const shopifyLogout = () => get(`${location.origin}/account/logout`);

// shopify get sections
export const shopifySection = (section) => get(`${location.origin}/?sections=${section}`);

// shopify add to cart
export const shopifyCartAdd = (param) => post(`${location.origin}/cart/add.js`, param);

// account system check user availability
export const shopifyUserCheck = (checkJackeryToken = "") => get("/userapi/v1/user/check", {check_jackery_token: checkJackeryToken});

// get a coupon for a single product
export const getCouponInfo = (variantId, price) => {
  price && (price = parseFloat(price / 100).toFixed(2));
  return get("/v1/app-coupon/info", { sku_id: variantId, price })
};

// get coupons for multiple products
// [{ sku_id: variantId, price }]
export const batchCouponInfo = (param) => get("/v1/app-coupon/batch-info", param);

// product shortage tips
export const shortage = (param) => post("/v1/notice/add", param);

// jackery day collection for answer active email
// param: {shopify_shop_id: '{{ shop.id }}'}
export const getServerTime = () => get("/v1/com/get-server-time", { shopify_shop_id: shopId });

// get notify current info
export const notifyInfo = () => get("/v1/app-message/info", { union_id: cookie.get("_shopify_y"), shopify_shop_id: shopId });

// notify popup
export const notifyPopup = (param) => post("/v1/app-message/popup", param);

// footer电话订阅
export const footerPhoneSubs = (params) => post("/osconsumerapi/v1/notice/subscribe", { shopify_shop_id: shopId, ...params });


// 智能选购相关接口
// 功能是否开启
export const isHelpChooseOpen = () => get('/osconsumerapi/cusumer/smartshop/openstutas', {shopifyShopId: shopId})

// 获取 主场景列表
export const getMainScene = () => get('/osconsumerapi/cusumer/smartshop/mianscene', {shopifyShopId: shopId})

// 添加 其他主场景
export const addOtherMainScene = (params) => post('/osconsumerapi/cusumer/smartshop/other-main-scene', {shopifyShopId: shopId, ...params})

// 获取 子场景列表
export const getSubScene = (params) => get('/osconsumerapi/cusumer/smartshop/subscene', {shopifyShopId: shopId, ...params})

// 获取 电器列表
export const getElectrical = (params) => post('/osconsumerapi/cusumer/smartshop/electrical', {shopifyShopId: shopId, ...params})

// 获取 储能和太阳能板子推荐
export const getBothGoods = (params) => post('/osconsumerapi/cusumer/smartshop/bothgoods', {shopifyShopId: shopId, ...params})

// 获取 储能和太阳能板子价格和参数
export const getBothGoodsPrice = (params) => post('/osconsumerapi/cusumer/smartshop/price', {shopifyShopId: shopId, ...params})

// 获取 储能单品推荐
export const getResultSingleGoods = (params) => post('/osconsumerapi/cusumer/smartshop/singlegoods', {shopifyShopId: shopId, ...params})

// 获取 储能 + 太阳能板 推荐
export const getResultGoodsList = (params) => post('/osconsumerapi/cusumer/smartshop/goodslist', {shopifyShopId: shopId, ...params})

// 获取 储能下拉列表
export const getEnergyList = (params) => get('/osconsumerapi/cusumer/smartshop/energylist', {shopifyShopId: shopId, ...params})

// 获取 太阳能列表
export const getSolarList = (params) => get('/osconsumerapi/cusumer/smartshop/solarlist', {shopifyShopId: shopId, ...params})

// 获取 太阳能列表
export const getRecommendProducts = (params) => post('/osconsumerapi/cusumer/smartshop/page/recommend', {shopifyShopId: shopId, ...params})

// 获取 产品延保信息
export const getProductWarrantyInfo = (params) => get('/osconsumerapi/cusumer/smartshop/warranty', {shopifyShopId: shopId, ...params})


// 通过产品ID获取捆绑销售详情
export const bundleSale = (params) => get('/osconsumerapi/app-bundle-sale/consumer/info', {shopifyShopId: shopId, ...params})

// 通过产品ID获取产品对比信息
export const productContrast = (params) => get('/osconsumerapi/app-product-comparison/consumer/compareInfo', {shopifyShopId: shopId, ...params})

// 通过产品ID获取产品基础属性信息
export const productBaseInfo = (params) => get('/osconsumerapi/app-product-comparison/consumer/detail', {shopifyShopId: shopId, ...params})
// 获取选定产品的对比信息
export const productSelectCompareInfo = (params) => get('/osconsumerapi/app-product-comparison/consumer/selectCompareInfo', {shopifyShopId: shopId, ...params})

// 获取系列所有产品
export const productAllCompareInfo = (params) => get('/osconsumerapi/app-product-comparison/consumer/allCompareInfo', {shopifyShopId: shopId, ...params})

/*-- 新客任务 --*/
// C端：获取活动详情接口
export const customerInfo = (params) => get('/osconsumerapi/v1/newcomer-subscribe/info', {shopify_shop_id: shopId, ...params});

// C端：参与活动接口
// export const customerJoin = (params) => get('/osconsumerapi/v1/newcomer-subscribe/join', {shopify_shop_id: shopId, ...params});
export const customerJoin = (params) => post('/osconsumerapi/v1/newcomer-subscribe/new-join', {shopify_shop_id: shopId, ...params});

// C端：获取奖品结果接口
export const customerResult = (params) => get('/osconsumerapi/v1/newcomer-subscribe/result', {shopify_shop_id: shopId, ...params});

// C端：电话订阅接口
export const customerPhone = (params) => get('/osconsumerapi/v1/newcomer-subscribe/accepts-sms', {shopify_shop_id: shopId, ...params});

// C端：数据上报接口
export const customerPopData = (params) => get("/v1/newcomer-subscribe/popup", {shopify_shop_id: shopId, ...params});

// C端：人机校验接口
export const checkRobot = (params) => post("/v1/newcomer-subscribe/robot-check", {shopify_shop_id: shopId, ...params});
/*-- 新客任务 --*/

// become-reseller页面submit
export const resellerSubmit = (params) => post("/osconsumerapi/v1/service/dealer-application", {...params});

/*-- contact us页面 --*/
// C端：contact us页面-前端表单转发到对应收集邮件邮件
export const contactMediaSubmit = (params) => post("/osconsumerapi/v1/service/media-cooperation", {...params});

// C端：contact us页面-上传文件
export const contactMediaUpload = (params) => post("/osconsumerapi/v1/aws/upload?type=2", params, {feature: 'upload'});

// C端：contact us页面-获取分类数据   osconsumerapi/contact/us/consult/field/detail
export const getCategory = (params) => get("/osconsumerapi/contact/us/consult/field/detail", {...params});
// export const getCategory = (params) => get("/shopconsult/open/consult/field/17948055445787/detail", {...params}, {type:'it-java'});

// C端：contact us页面-获取商品数据
// export const getProductName = (params) => get("/open/consult/field/5845813794575/detail", {...params}, {type:'it-java'});
// export const getProductName = (params) => get("/shopconsult/open/consult/field/7492361159707/detail", {...params}, {type:'it-java'});
export const getProductName = (params) => get("/osconsumerapi/contact/us/consult/field/group", {...params});

// C端：contact us页面-zendesk上传附件
export const zendeskUpload = (params) => post("/osconsumerapi/contact/us/consult/upload", params, {feature: 'upload'});

// C端：contact us页面-zendesk提交表单
// export const zendeskSubmit = (params) => post("/shopconsult/open/consult/create", {...params}, {type:'it-java'});

export const zendeskSubmit = (params) => post("/osconsumerapi/contact/us/consult/create", {...params});

// industry列表
export const getIndustryList = (params) => get("/osconsumerapi/contact/us/consult/field/industry", {...params});

// 提交 - 批量购买再用
export const zendeskContactSubmit = (params) => post("/osconsumerapi/contact/us/retailPage/create", {...params});


/*-- contact us页面 --*/

// 获取ip列表
export const regoinlist = (params) => get("/osconsumerapi/cusumer/ip/regoinlist", { shopifyShopId: shopId, ...params });



// 获取会员最大权益-未登录
export const getMembershipBenefits = params => get("/userapi/v1/point/benefits/public", { shopifyShopId: shopId, ...params })

// 获取会员最大权益-已登录
export const getLoginMembershipBenefits = params => get("/userapi/v1/point/benefits/login", { shopifyShopId: shopId, ...params })


// 获取心愿单配置-心愿单
export const getGoodsWishList = params => get("/osconsumerapi/v1/goods/get-goods-wish-list", { shopifyShopId: shopId, ...params })

// 更新心愿单-心愿单
export const updateGoodsWishList = params => post("/osconsumerapi/v1/cust-wish-list/update-wish-list", { shopifyShopId: shopId, ...params })

// 登出接口
export const accountLogout = () => get("/userapi/v1/user/logout", {shopifyShopId: shopId})

// 地图接口 - 地图列表
export const getStoreList = params => post("/osconsumerapi/v1/map/list", { shopifyShopId: shopId, ...params })

// 获取地图国家
export const getCountryOrRegionList = params => get("/osconsumerapi/v1/map/country", { shopifyShopId: shopId, ...params })

// 获取地图省份
export const getProvinceList = params => get("/osconsumerapi/v1/map/province", { shopifyShopId: shopId, ...params })

// 获取地图城市
export const getCityList = params => get("/osconsumerapi/v1/map/city", { shopifyShopId: shopId, ...params })
// 批量购买--列表
export const getBatchPurchaseList = () => get("/osconsumerapi/v1/app-batch-discount/bulkInfo", {shopifyShopId: shopId})

// 上传免税证明
export const uploadBatchPurchaseInfo = (params) => post("/osconsumerapi/v1/tax/upload", {shopShopifyId: shopId, ...params})

// 下载报价单
export const downloadBatchPurchaseExcal = (params) => postDownload('/osconsumerapi/v1/app-batch-discount/download', {shopShopifyId: shopId, ...params})

// 日站下载报价单
export const downloadJpBatchPurchaseExcal = (params) => postDownload('/osconsumerapi/v1/app-batch-discount/download-jp', {shopShopifyId: shopId, ...params})

// C端 批量上传：-上传文件  下次要改下
export const batchPurchaseUpload = (type, params) => post(`/osconsumerapi/v1/aws/upload?type=${type}`, params, {feature: 'upload'});

// 根据产品spuid来获取产品详细信息
export const getProductInfo = params => get("/osconsumerapi/v1/goods/productInfo", { shopifyShopId: shopId, ...params })

// 根据cr获取城市
export const countryStreetInfo = (params) =>  get('/osconsumerapi/v1/service/country-info', { shopifyShopId: shopId, ...params });

// 发送邮件
export const sendEmailAPI = (params) => post("/osconsumerapi/v1/com/email", { ...params });

// 12周年--获取商品列表sku
export const getGoodsList = () => get("/osconsumerapi/api/jackerylife/goods", { shopifyShopId: shopId });

// 12周年 -- 新增评论表单
export const addComment = (params) => post("/osconsumerapi/v1/comment/twelve/add", {shopShopifyId: shopId, ...params})

// 12周年--评论列表
export const getCommentList = (params) => get("/osconsumerapi/v1/comment/twelve/list", { shopShopifyId: shopId, ...params });

// 说明书
export const getManualList = (params) => get("/osconsumerapi/v1/goods/user-guides", { shopifyShopId: shopId, ...params });

// 获取AWS S3桶鉴权信息
export const getAwsS3Data = () => get("/osconsumerapi/v1/aws/get-sts", { auth: false });

// 获取付费延保服务信息
export const getPEWServiceInfo = (params) => get("/osconsumerapi/v1/paid-extended-warranty/get-service-info", {...params });

// 校验付费延保项目是否已激活或待审核（不包含取消）
export const checkPEWProject = (params) => get("/osconsumerapi/v1/paid-extended-warranty/check-warranty-project", {...params });

// 提交付费延保绑定申请
export const applyPEW = (params) => post("/osconsumerapi/v1/paid-extended-warranty/apply", {...params})


// 产品对比 - 获取产品列表
export const getCompareGoodsList = (params) => get("/osconsumerapi/v1/app-four-comparison/consumer/collection-goods", { shopifyShopId: shopId, ...params });

// 产品对比 - 获取详情
export const getCompareDetail = (params) => post("/osconsumerapi/v1/app-four-comparison/consumer/collection-detail", { shopifyShopId: shopId, ...params });

/** 智能选购 4.0 */
// 获取主场景列表
export const getSceneList = (params) => get('/userapi/cus/four/smartshop/scene', params)
// 获取电器列表
export const getElectricalList = (params) => get('/userapi/cus/four/smartshop/electrical', params)
// 查询最大功率
export const queryMaxPower = (params) => get('/userapi/cus/four/smartshop/maxpower', params)
// 储能单品推荐
export const getRecommendEnergy = (params) => get('/userapi/cus/four/smartshop/energy', params)
// 储能和太阳能板子推荐
export const getRecommendEnergySolar = (params) => get('/userapi/cus/four/smartshop/energysolar', params)
// 储能太阳能板配件最后推荐
export const getRecommendSolution = (params) => get('/userapi/cus/four/smartshop/solution', params)
// Get My Offer
export const getMyOffer = (params) => post('/userapi/cus/four/smartshop/myoffer', params)
/** 智能选购 4.0 */

/** 用户反馈 */
export const saveUserFeedback = (params) => post('/userapi/four/smart/shop/user/feedback', params)
/** 用户反馈 */

// Google 人机校验
export const googleRobotCheck = (params) => post("/osconsumerapi/consumer/act/robot-check", {...params });

// 产品推荐
export const getGoodsRecommend = (params) => get("/osconsumerapi/v1/goods/get-recommends", { shopifyShopId: shopId, ...params });
// 获取站点下单积分规则
export const getPointsRatio = (params) => get('/osconsumerapi/v1/point/getRatio', params)
